import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'localizedDate'
})
export class LocalizedDatePipe implements PipeTransform {
	transform(date: string | number, displayTime = true): string {
		if (!date) return '-';

		if (displayTime) {
			return new Date(date).toLocaleString();
		}

		return new Date(date).toLocaleDateString();
	}
}
